import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SelectOptionI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { State } from '../../reducers';
import { map } from 'rxjs/operators';
import { OneClickBuilderField } from '../../util/constants/builder-fields';
import { podsWithPreloaded } from '../../selectors/one-click-point-of-deliveries.selector';

@Injectable()
export class OneClickPointOfDeliveriesLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(podsWithPreloaded),
      map(({ pods, preloadedOrder }) => {
        if (preloadedOrder) {
          const _pod = preloadedOrder.pointOfDelivery;
          formGroup.controls[OneClickBuilderField.PointOfDelivery].setValue(_pod.pointOfDeliveryId);
          return [
            {
              id: _pod.pointOfDeliveryId,
              name: `${_pod.pointOfDeliveryCode.replace(/^0+/, '')} / ${_pod.pointOfDeliveryDesc}`,
            },
          ];
        }
        return pods.map((shippingDestination) => {
          return {
            id: shippingDestination.shippingDestinationId,
            name: `${shippingDestination.shippingDestinationCode.replace(/^0+/, '')} / ${
              shippingDestination.shippingDestinationDesc
            }`,
          };
        });
      }),
    );
  }
}
